import { createPortal } from 'react-dom';

/**
 * @typedef {Object} PortalProps
 * @property {import('react').ReactNode} children
 * @property {Element | DocumentFragment | null} [container]
 */

/**
 * @param {PortalProps} props
 */
const Portal = ({ children, container }) => {
	const targetContainer = container ?? document.body;

	if (!targetContainer) return null;

	return createPortal(children, targetContainer);
};

export default Portal;
